export var MuiOutlinedInput = {
    styleOverrides: {
        notchedOutline: function (_a) {
            var theme = _a.theme;
            return ({
                borderColor: theme.palette.grey[600],
            });
        },
    },
};
